import type { AppSaveBarProps } from "./app-save-bar.type";

import { useTranslation } from "react-i18next";

import RouterBlocker from "@/components/RouterBlocker";
import { SaveBar } from "@/ui/save-bar";

import { useSaveBar } from "./app-save-bar.hook";

const AppSaveBar = ({
  loading = false,
  sticky = false,
  date,
  onSave,
  onCancel,
}: AppSaveBarProps) => {
  const { t } = useTranslation();
  const { isDirty, isSaving } = useSaveBar();

  return (
    <>
      <RouterBlocker
        // Block navigation when form saving or form has changes not saved yet.
        // But do not show modal when form saving...
        shouldBlockFn={() => isSaving || isDirty}
        shouldShowModal={!isSaving}
        title={t("global:leavePage")}
        message={t("global:unsavedChanges")}
        onConfirm={onCancel}
      />
      <SaveBar
        loading={isSaving || loading}
        hasChanges={isDirty}
        sticky={sticky}
        date={date}
        onSave={onSave}
        onCancel={onCancel}
      />
    </>
  );
};

export default AppSaveBar;
